import React from "react";
import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ss1 from "../assets/imgs/new/ss1.png";
import ss2 from "../assets/imgs/new/ss2.png";
import ss3 from "../assets/imgs/new/ss8.png";

import pic2 from "../assets/imgs/new/pic2.png";
import pic3 from "../assets/imgs/new/pic3.png";
import pic4 from "../assets/imgs/new/pic4.png";

import ss7_2 from "../assets/imgs/new/ss7_2.png";
import buyme from "../assets/imgs/accessPageImgs/buyme.png";

import col2pic1 from "../assets/imgs/accessPageImgs/col2pic1.png";
import col2pic2 from "../assets/imgs/accessPageImgs/col2pic2.png";
import col2pic3 from "../assets/imgs/accessPageImgs/col2pic3.png";
import col2pic4 from "../assets/imgs/accessPageImgs/col2pic4.png";
import col2pic5 from "../assets/imgs/accessPageImgs/col2pic5.png";

import colss1 from "../assets/imgs/accessPageImgs/col-ss1.png";
import colss2 from "../assets/imgs/accessPageImgs/col-ss2.png";
import colss3 from "../assets/imgs/accessPageImgs/col-ss3.png";

import col2ss1 from "../assets/imgs/accessPageImgs/col2-ss1.png";
import col2ss2 from "../assets/imgs/accessPageImgs/col2-ss2.png";

import p21 from "../assets/imgs/accessPageImgs/p21.png";

import ss10 from "../assets/imgs/new/ss10.png";
import share from "../assets/svgs/share.svg";

import ShareModal from "../components/ShareModal";
function Landingpage() {
  const images = [buyme, pic2, , pic3, pic4];

  const [isShareVisible, setIsShareVisible] = useState(false);
  const videoRef = useRef(null);
  const video2Ref = useRef(null);
  const video3Ref = useRef(null);
  const navigate = useNavigate();

  const handleNavigation = () => {
    navigate("/access");
  };

  const handleShareClick = () => {
    setIsShareVisible(true);
  };

  const handleClose = () => {
    setIsShareVisible(false);
  };

  // auto play for video one
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play();
    }
  }, []);
  useEffect(() => {
    if (video2Ref.current) {
      video2Ref.current.play();
    }
  }, []);
  useEffect(() => {
    if (video3Ref.current) {
      video3Ref.current.play();
    }
  }, []);

  return (
    <div className="min-h-screen  content-center" style={{ backgroundColor: "#042543" }}>
      <div className="grid grid-cols-1 lg:gap-0 gap-0">
        {/* Images */}

        {images.map((image, index) => (
          <div key={index} className="rounded overflow-hidden ">
            {index === 0 ? (
              <a
                href="https://buymeacoffee.com/greghalpern"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={image}
                  alt={`Image ${index + 1}`}
                  className="w-full h-auto object-cover px-[5%] sm:px-[9%]"
                />
              </a>
            ) : index === 4 ? (
              <a
                href="https://whatthatmeans.net/trends"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={image}
                  alt={`Image ${index + 1}`}
                  className="w-full h-auto object-cover sm:w-[110%]"
                />
              </a>
            ) : index === 3 ? (
              <a
              href="https://whatthatmeans.net/access"
              target="_blank"
              rel="noopener noreferrer"
            >
              
              <div onClick={handleNavigation} className="cursor-pointer">
                <img
                  src={image}
                  alt={`Image ${index + 1}`}
                  className="w-full h-auto object-cover sm:w-[110%]"
                />
              </div>
              </a>
            ) : (
              <img
                src={image}
                alt={`Image ${index + 1}`}
                className="w-full h-auto object-cover sm:w-[110%]"
              />
            )}
          </div>
        ))}

        {/* col ss 1 to 3 */}

        <div className="fixed mt-[20%] ml-[70%] md:ml-[85%] ">
          <img
            src={share}
            alt="share icon"
            className=" cursor-pointer w-[120%] md:w-[80%]"
            onClick={handleShareClick}
          />
        </div>
      </div>

      {isShareVisible && <ShareModal onClose={handleClose} />}
    </div>
  );
}

export default Landingpage;
